module.exports = __webpack_public_path__ + "static/media/hacktheplanet.ffa534fd.gif";